import {useSyncExternalStore} from "react";
import {StorageManager} from "@features/storage-manager/storage-manager";
import {OrderDTO} from "@dto/OrderDTO";
import {isOrderPickup} from "@entities/order/lib/resolvers";

export enum RECEIVING_TYPE_FILTER {
    ALL = "all",
    DELIVERY = "delivery",
    PICKUP = "pickup",
}

export const matchesReceivingTypeFilter = (order: OrderDTO, filter: RECEIVING_TYPE_FILTER) => {
    if (filter === RECEIVING_TYPE_FILTER.PICKUP) return isOrderPickup(order)
    if (filter === RECEIVING_TYPE_FILTER.DELIVERY) return !isOrderPickup(order)
    return true
}

// Shared between the orders layout (filter control), orders list and header
// (new-orders sound), so it lives outside React state and is persisted per cashier window.
let currentFilter: RECEIVING_TYPE_FILTER = StorageManager.getFromLocal(
    StorageManager.KEYS.ORDERS_RECEIVING_TYPE,
    RECEIVING_TYPE_FILTER.ALL
)

const listeners = new Set<() => void>()

const subscribe = (listener: () => void) => {
    listeners.add(listener)
    return () => {
        listeners.delete(listener)
    }
}

const getSnapshot = () => currentFilter

export const setReceivingTypeFilter = (filter: RECEIVING_TYPE_FILTER) => {
    currentFilter = filter
    StorageManager.setToLocal(StorageManager.KEYS.ORDERS_RECEIVING_TYPE, filter)
    listeners.forEach((listener) => listener())
}

export const useReceivingTypeFilter = () => {
    const receivingTypeFilter = useSyncExternalStore(subscribe, getSnapshot)
    return {receivingTypeFilter, setReceivingTypeFilter}
}
